import { render, staticRenderFns } from "./ZChome.vue?vue&type=template&id=34c5abbe&scoped=true&"
import script from "./ZChome.vue?vue&type=script&lang=ts&"
export * from "./ZChome.vue?vue&type=script&lang=ts&"
import style0 from "./ZChome.vue?vue&type=style&index=0&id=34c5abbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c5abbe",
  null
  
)

export default component.exports